
export default {
    Image : "image",
    Text : "text"
}
